import { TenantBaseApi } from "api/TenantSlug/TenantBaseApi.ts";

import GetProcessRefuseLeadSettingRequest = App.Http.Requests.RefuseLeadSettings.GetRefuseLeadSettingRequest;
import GetProcessRefuseLeadSettingsRequest = App.Http.Requests.RefuseLeadSettings.GetRefuseLeadSettingsRequest;
import GetProcessRefuseLeadSettingResponse = App.Http.Responses.RefuseLeadSettings.GetProcessRefuseLeadSettingResponse;
import GetProcessRefuseLeadSettingsResponse = App.Http.Responses.RefuseLeadSettings.GetProcessRefuseLeadSettingsResponse;
import StoreProcessRefuseLeadSettingRequest = App.Http.Requests.RefuseLeadSettings.StoreRefuseLeadSettingRequest;
import UpdateProcessRefuseLeadSettingRequest = App.Http.Requests.RefuseLeadSettings.UpdateRefuseLeadSettingRequest;

class ProcessRefuseLeadSettingsApi extends TenantBaseApi {
    /**
     * Get list of process refuse lead settings
     *
     * - Request: GetProcessRefuseLeadSettingsRequest
     * - Response: GetProcessRefuseLeadSettingsResponse
     */
    async index(offerId: string, request: GetProcessRefuseLeadSettingsRequest): Promise<GetProcessRefuseLeadSettingsResponse> {
        return await this.get<GetProcessRefuseLeadSettingsResponse, GetProcessRefuseLeadSettingsRequest>(
            `/offers/${offerId}/process-refuse-lead-settings`,
            {
                params: request,
            }
        );
    }

    /**
     * Get specific process refuse lead setting
     *
     * - Request: GetProcessRefuseLeadSettingRequest
     * - Response: GetProcessRefuseLeadSettingResponse
     */
    async show(offerId: string, refuseLeadSettingId: string, request: GetProcessRefuseLeadSettingRequest): Promise<GetProcessRefuseLeadSettingResponse> {
        return await this.get<GetProcessRefuseLeadSettingResponse, GetProcessRefuseLeadSettingRequest>(
            `/offers/${offerId}/process-refuse-lead-settings/${refuseLeadSettingId}`,
            {
                params: request,
            }
        );
    }

    /**
     * Store process refuse lead setting
     *
     * - Request: StoreProcessRefuseLeadSettingRequest
     * - Response: GetProcessRefuseLeadSettingResponse
     */
    async store(offerId: string, request: StoreProcessRefuseLeadSettingRequest): Promise<GetProcessRefuseLeadSettingResponse> {
        return await this.post<GetProcessRefuseLeadSettingResponse, StoreProcessRefuseLeadSettingRequest>(
            `/offers/${offerId}/process-refuse-lead-settings`,
            request
        );
    }

    /**
     * Update process refuse lead setting
     *
     * - Request: UpdateProcessRefuseLeadSettingRequest
     * - Response: GetProcessRefuseLeadSettingResponse
     */
    async update(offerId: string, refuseLeadSettingId: string, request: UpdateProcessRefuseLeadSettingRequest): Promise<GetProcessRefuseLeadSettingResponse> {
        return await this.put<GetProcessRefuseLeadSettingResponse, UpdateProcessRefuseLeadSettingRequest>(
            `/offers/${offerId}/process-refuse-lead-settings/${refuseLeadSettingId}`,
            request
        );
    }

    /**
     * Delete process refuse lead setting
     *
     * - Response: void
     */
    async destroy(offerId: string, refuseLeadSettingId: string): Promise<void> {
        return await this.delete(`/offers/${offerId}/process-refuse-lead-settings/${refuseLeadSettingId}`);
    }
}

export const processRefuseLeadSettingsApi = new ProcessRefuseLeadSettingsApi();
